import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

import { type ICostCatalogProps } from "entity/costCatalog/CostCatalog.types";

const CostCatalog = lazyLoadWithRetry(() => import("./CostCatalog"));

export interface IRouteCostCatalogProps
    extends Omit<ICostCatalogProps, "history" | "location" | "match"> {
    path?: string;
}
export const RouteCostCatalog: React.FunctionComponent<IRouteCostCatalogProps> = (props) => (
    <RouteRelative
        path={props.path ?? routes.costCatalog.addFromCatalog}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <CostCatalog {...props} {...routeProps} />
                </BTSuspense>
            );
        }}
    />
);
